import type Organization from "@/domain/entities/organization/Organization";
import type OrganizationUser from "@/domain/entities/organization/OrganizationUser";
import type { UserWithLicense } from "../types";

type BuildUsersWithLicenseParams = {
    adminCount: number;
    isUserAdmin: (userMail: string) => boolean;
    organization?: Organization;
    organizationUsers?: OrganizationUser[];
};

export const buildUsersWithLicense = ({
    adminCount,
    isUserAdmin,
    organization,
    organizationUsers,
}: BuildUsersWithLicenseParams): UserWithLicense[] => {
    const isLastAdmin = adminCount <= 1;

    return (
        organizationUsers?.map((user) => {
            const matchedOrgLicense = organization?.licenses.find(
                (license) => license.licenseId === user.license?.licenseId,
            );

            return {
                isAdmin: isUserAdmin(user.mail),
                isLastAdmin: isLastAdmin && isUserAdmin(user.mail),
                isMonthlyAnalyzedMailLimitReached:
                    user.isMonthlyAnalyzedMailLimitReached,
                licenseId: matchedOrgLicense?.id,
                userMail: user.mail,
                userId: user.id,
            };
        }) ?? []
    );
};
